import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { PermissionsInfo } from '../components/permissions-info';
import { TcmModalService } from '../modules/tcm-common/services/tcm-modal.service';
import { ReflectionHelper } from '../helpers/reflection.helper';

@Injectable()
export class ModalGuard  {
  constructor(private router: Router, private modalService: TcmModalService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (route.params.mode == 'modal') {
      const model = route.queryParams.params ? JSON.parse(route.queryParams.params) : {}
      const size = route.params.size;

      const componentOptions = { requestModel: model, permissionsInfo: route.data as PermissionsInfo };

      if (typeof route.component !== 'string' && ReflectionHelper.isSecureComponent(route.component)) {
        this.modalService.openSecureComponentInModal(route.component, componentOptions, size || 'lg');
      }
      else {
        this.modalService.openComponentInModal(route.component, size || 'lg', componentOptions);
      }

      return false;
    }

    return true;
  }
}
